// extracted by mini-css-extract-plugin
module.exports = {"defaultStyle":"ConnectToExchangeButton_defaultStyle__-xoGW"};